// deprecated
import {createAction} from 'redux-actions';

import {
  GET_TAXES_SUCCESS,
  CLEAR_TAXES
} from '../config/const';

export const getTaxesSuccess = createAction(GET_TAXES_SUCCESS, taxes => taxes);
export const clearTaxes = createAction(CLEAR_TAXES);


const initialState = null;

const taxesReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_TAXES_SUCCESS:
    return {...action.payload};
  case CLEAR_TAXES:
    return null;
  default:
    return state;
  }
};

export default taxesReducer;



// WEBPACK FOOTER //
// ./src/reducers/taxesReducer.js